import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledContentStack = styled(Stack)({
  height: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 0.33fr",
  gap: "15px",
});

export const StyledMonthGrid = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gridAutoRows: "minmax(200px, 1fr)",
  gap: "12px",
  overflow: "auto",
});

export const StyledMonthCard = styled(Stack)(({ theme }) => ({
  padding: "8px",
  borderRadius: "6px",
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  backgroundColor: theme.palette.hubColors.white,
  overflow: "hidden",
  maxHeight: "300px",
}));

export const StyledDayCell = styled(Stack, {
  shouldForwardProp: (p) => !["isToday", "isClosed", "isWeekend"].includes(p),
})(({ theme, isToday, isClosed, isWeekend: weekend }) => ({
  position: "relative",
  width: "100%",
  minHeight: 25,
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  cursor: weekend ? "default" : "pointer",
  fontSize: 10,
  fontWeight: isToday ? 700 : 400,
  ...(isToday && {
    boxSizing: "border-box",
    color: theme.palette.hubColors.mainFocus,
  }),
  ...(weekend &&
    !isClosed && {
      opacity: 0.6,
    }),
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 1,
    left: "25%",
    width: "50%",
    height: 2,
    borderRadius: 1,
    ...(isClosed && {
      backgroundColor: theme.palette.hubColors.redMain,
    }),
    ...(weekend &&
      !isClosed && {
        backgroundColor: theme.palette.hubColors.greyMid,
      }),
  },
  "&:hover": {
    ...(!weekend && {
      backgroundColor: theme.palette.hubColors.greyLightTransparent,
    }),
  },
}));
